import React from 'react'

const Footer = () => {
    return (
        <footer id='footer' role='contentinfo'>
            <a
                href="mailto: answlsgh95@gmail.com"
                rel='nonopener noreferrer'>
                answlsgh95@gmail.com
            </a>
        </footer>
    )
}

export default Footer